<template lang="html">
  <div id="contact-page">

    <section class="container form-section">
      <div class="row justify-content-center">
        <div class="col-12 col-info">
          <h1 class="mb-3 title-s1 c-primary">Contacto</h1>

          <p>
            Si tienes alguna duda no dudes en contactarnos.
          </p>
        </div>

        <div class="col-xl-9 col-form">
          <b-form @submit="onSubmit">
            <b-form-group class="form-group-s1"
              label="Nombre:">
              <b-form-input
                v-model="form.name"
                type="text"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="form-group-s1"
              label="Correo electrónico:">
              <b-form-input
                v-model="form.email"
                type="email"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="form-group-s1"
              label="Teléfono:">
              <b-form-input
                v-model="form.phone"
                type="text"
                placeholder=""
                required
              ></b-form-input>
            </b-form-group>

            <b-form-group class="form-group-s1"
              label="Mensaje:">
              <b-form-textarea
                v-model="form.msg"
                placeholder=""
                rows="4"
                max-rows="4"
                required
              ></b-form-textarea>
            </b-form-group>

            <p class="text-center">
              <b-button type="submit" class="btn-s1 bg-cprimary">Enviar</b-button>
            </p>
          </b-form>
        </div>
      </div>
    </section>

  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        name: null,
        email: null,
        phone: null,
        msg: null,
      }
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-bottom-right',
        appendToast: true
      })
    },

    onSubmit(event) {
      event.preventDefault();

      var params = this.form;
      var apiURL = tools.url("/api/contact");

      axios.post( apiURL,params )
      .then( (response) => {
        // alert(response.data.response);
        this.makeToast('success', response.data.response, 'Mensaje enviado');
        // alert(response.data.response);

        for (let prop in this.form) {
          this.form[prop] = '';
        }
      })
      .catch( (error) => {
        // console.log(error.response.data);
        let errors = error.response.data;

        for (let prop in errors) {
          // console.log(errors[prop]);
          this.makeToast('danger', errors[prop], '¡Error!');
        }
      });
    },
  }
}
</script>
